import { isEmpty } from 'lodash'
import { change, isDirty } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { IReservationFormChange } from '../../../actions/bookingCalendar/reservationModal/onReservationFormChange'
import { ReservationModalActions } from '../../../reducers/bookingCalendar/actionNames'

function* changeAdditionalGuests(action: IReservationFormChange) {
  const dirty = yield Effects.select(isDirty(action.formName))

  if (
    dirty &&
    (action.values.childrenCount !== action.prevValues.childrenCount ||
      action.values.adultsCount !== action.prevValues.adultsCount)
  ) {
    const additionalGuestsCount = Math.max(
      Number(action.values.childrenCount) +
        Number(action.values.adultsCount) -
        1,
      0,
    )

    yield Effects.put(
      change(action.formName, 'additionalGuests', additionalGuests => {
        const guestsArray = isEmpty(additionalGuests) ? [] : additionalGuests

        return guestsArray
          .slice(0, additionalGuestsCount)
          .concat(
            Array(Math.max(additionalGuestsCount - guestsArray.length, 0)).fill(
              {},
            ),
          )
      }),
    )
  }
}

export default function* () {
  yield Effects.takeLatest(
    ReservationModalActions.OnChange,
    changeAdditionalGuests,
  )
}
